<template>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Type</th>
            <th class="text-left">Passengers</th>
            <th class="text-left">Luggage</th>
            <th class="text-left">Description</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.type }}</td>
            <td>{{ item.passengers }}</td>
            <td>{{ item.luggage }}</td>
            <td>{{ item.description }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
</template>

<script>
export default {
  name: "LuggageInfoBox",
  data: () => ({
    items: [
      {
        id: '1',
        type: 'Saloon',
        passengers: 'Up to 4',
        luggage: '2-3 cases',
        description: 'A standard family sized saloon car. Ideal for small groups and individual travellers.'
      },
      {
        id: '2',
        type: 'Estate',
        passengers: '2 Pax',
        luggage: '4 cases',
        description: 'The estate car provides a generous amount of luggage space. Ideal for passengers carrying excess luggage.'
      },
      {
        id: '3',
        type: 'Estate',
        passengers: '3 Pax',
        luggage: '3 cases',
        description: 'The estate car provides a generous amount of luggage space. Ideal for passengers carrying excess luggage.'
      },
      {
        id: '4',
        type: '6-Seater',
        passengers: 'Up to 6 without luggage / 4 with luggage',
        luggage: 'None with 6 passengers / 4 cases with 4 passengers',
        description: 'This vehicle is designed to carry passengers without luggage. Can take 4 passengers and luggage with 2 extra seats folded down.'
      },
      {
        id: '5',
        type: '8-Seater',
        passengers: 'Up to 8',
        luggage: '8 large suitcases',
        description: 'Our 8 seater minivans can carry large groups with excess luggage and things such as skis and cycles.'
      },
      {
        id: '6',
        type: 'Executive',
        passengers: 'Same as saloon',
        luggage: 'Same as saloon',
        description: 'The executive car is a more executive vehicle such as Mercedes E Class or equivalent for extra leg room.'
      }
    ]
  })
};
</script>
